import React, { useState } from 'react';
import { FiTool, FiPlay } from 'react-icons/fi';
import ToolsSidebar from '../components/ToolsSidebar';

const initialData = [];

export default function Tools() {
  const [data] = useState(initialData);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <ToolsSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1">
          <div className="flex items-center space-x-2">
            <FiTool className="text-xl text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">System Tools ({data.length})</span>
          </div>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black">
          <table className="min-w-full border-collapse text-[12px]">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900">
                <th className="p-2 border border-black text-left">Tool Name</th>
                <th className="p-2 border border-black text-left">Description</th>
                <th className="p-2 border border-black text-left">Last Run</th>
                <th className="p-2 border border-black text-center">Status</th>
                <th className="p-2 border border-black text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr key={idx} className="hover:bg-blue-50">
                  <td className="p-2 border border-black font-bold">{row.name}</td>
                  <td className="p-2 border border-black">{row.desc}</td>
                  <td className="p-2 border border-black">{row.lastRun}</td>
                  <td className="p-2 border border-black text-center"><span className="bg-gray-100 px-2 py-0.5 rounded border">{row.status}</span></td>
                  <td className="p-2 border border-black text-center">
                    <button className="bg-blue-100 text-blue-800 px-2 py-1 rounded hover:bg-blue-200"><FiPlay /></button>
                  </td>
                </tr>
              ))}
              {data.length === 0 && <tr><td colSpan="5" className="p-4 text-center text-gray-500">No tools available.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}